import { ReactNode, useState } from "react";
import dynamic from "next/dynamic";
import styled from "styled-components";
import useChatLauncherViewModel from "./ChatLauncherViewModel";
import ChatLauncherContext from "@/src/shared/ChatLauncher/ChatLauncherContext";
import ChatWidget from "./ChatWidget/ChatWidget";
import squintAnimation from "@/public/lottie/niora/Squint.json";
import laughAnimation from "@/public/lottie/niora/Laugh.json";

const Lottie = dynamic(() => import("lottie-react"), { ssr: false });

const ChatLauncher = (): ReactNode => {
  const viewModel = useChatLauncherViewModel();
  const [animation, setAnimation] = useState<any>(squintAnimation);

  return (
    <ChatLauncherContext.Provider value={viewModel}>
      <StyledChatLauncher onMouseEnter={() => setAnimation(laughAnimation)} onMouseLeave={() => setAnimation(squintAnimation)}>
        <StyledChatButton isOpen={viewModel.isOpen}>
          <Lottie
            animationData={animation}
            onClick={viewModel.toggle}
            style={{
              width: 135,
              height: 135
            }}
          />
        </StyledChatButton>
      </StyledChatLauncher>
      <ChatWidget />
    </ChatLauncherContext.Provider>
  );
};

const StyledChatLauncher = styled.div`
  position: fixed;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  z-index: 10000;
`;

const StyledChatButton = styled.div<{ isOpen: boolean }>`
  align-self: flex-end;
  cursor: pointer;
  margin: -10px;
  transition: transform 0.3s ease;
  will-change: transform;
  transform: translateZ(0);

  &:hover {
    transform: ${({ isOpen }) => (!isOpen ? "scale(1.1)" : "none")};
  }

  @media only screen and (max-width: 991px) {
    margin: -16px;
  }
`;

export default ChatLauncher;
